@if (showBanner()) {
  <div class="system-message">
    {{ systemMessage()?.message }}
    <a rel="noopener" [href]="helpCenter" target="_blank">{{ systemMessage()?.title }}</a>
  </div>
}
